export default __webpack_public_path__ + "static/media/employee_template.3fce9ab7.xlsx";